import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pencil, Trash } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo, useMemo } from "react";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
import { CUSTOM_FIELD_EDIT_BUTTON, CUSTOM_FIELD_SELECT_LABEL } from "~/constants/testIDs";
export const CustomFieldLabel = /*#__PURE__*/ memo((param)=>{
    let { onClick, field, canDeleteCustomFields, canEditCustomFields } = param;
    const Icon = customFieldIconMap[field.type.title];
    const label = field.name;
    const iconAndLabel = useMemo(()=>/*#__PURE__*/ _jsxs("div", {
            className: "flex items-center gap-1 text-grey-10",
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    className: "size-3"
                }),
                label
            ]
        }), [
        Icon,
        label
    ]);
    return canDeleteCustomFields || canEditCustomFields ? /*#__PURE__*/ _jsx(Button, {
        appearance: "ghost",
        className: "group/custom-field-label -ml-2",
        color: "grey",
        "data-testid": "".concat(CUSTOM_FIELD_EDIT_BUTTON, "-").concat(label),
        onClick: onClick,
        suffix: canEditCustomFields || canDeleteCustomFields ? /*#__PURE__*/ _jsx("div", {
            className: "text-grey-10 opacity-0 group-focus-within/custom-field-label:opacity-100 group-hover/custom-field-label:opacity-100",
            children: canEditCustomFields ? /*#__PURE__*/ _jsx(Pencil, {
                className: "size-3"
            }) : canDeleteCustomFields ? /*#__PURE__*/ _jsx(Trash, {
                className: "size-3"
            }) : undefined
        }) : undefined,
        size: "small",
        children: iconAndLabel
    }) : /*#__PURE__*/ _jsx("div", {
        className: "flex h-6 items-center text-12",
        "data-testid": "".concat(CUSTOM_FIELD_SELECT_LABEL, "-").concat(label),
        children: iconAndLabel
    });
});
CustomFieldLabel.displayName = "CustomFieldLabel";
